module.exports = __webpack_public_path__ + "img/open-bracket-removebg-preview.c74a9c37.png";